import { WorkerLifecycleFilterValue } from './workerLifecycleFilterValue';

export type WorkerLifecycleFilterErrors = Partial<Record<
    'minimumFeedbackRating' | 'maximumFeedbackRating' | 'lastContactFrom' | 'lastContactTo',
    string
>>;

export function validateWorkerLifecycleFilters(
    value: WorkerLifecycleFilterValue,
): WorkerLifecycleFilterErrors {
    const errors: WorkerLifecycleFilterErrors = {};
    const minimum = value.minimumFeedbackRating;
    const maximum = value.maximumFeedbackRating;

    if (minimum !== undefined && (!Number.isInteger(minimum) || minimum < 1 || minimum > 10)) {
        errors.minimumFeedbackRating = 'Use a whole number from 1 to 10';
    }
    if (maximum !== undefined && (!Number.isInteger(maximum) || maximum < 1 || maximum > 10)) {
        errors.maximumFeedbackRating = 'Use a whole number from 1 to 10';
    }
    if (
        minimum !== undefined &&
        maximum !== undefined &&
        !errors.minimumFeedbackRating &&
        !errors.maximumFeedbackRating &&
        maximum < minimum
    ) {
        errors.maximumFeedbackRating = 'Maximum must be at least the minimum';
    }
    if (
        value.lastContactFrom &&
        value.lastContactTo &&
        value.lastContactFrom > value.lastContactTo
    ) {
        errors.lastContactTo = 'Last contact to must be on or after from';
    }

    return errors;
}

export function applyValidWorkerLifecycleFilters(
    filters: WorkerLifecycleFilterValue,
    apply: () => void,
): boolean {
    if (Object.keys(validateWorkerLifecycleFilters(filters)).length > 0) return false;
    apply();
    return true;
}
